<script>
  export let x;
  export let y;
</script>

<g>
  <circle class="point" cx={x} cy={y} r="5" />
</g>

<style>
  .point {
    fill: #4427ca;
  }
</style>
